import React, { Component } from 'react'
import styles from './remotesButton.module.scss'
import AddIcon from '../../img/icons/add-icon.svg'

export default class RemotesButton extends Component
{
    constructor(props)
    {
        super(props)
        
        this.state =
        {
            
        }
    }
    
    render()
    {
        return (
            <div className={styles.downloadBox} onClick={this.props.onClick}>
                <div className={styles.plusIconContainer}>
                    <img src={AddIcon} alt="Dar mandos" />
                </div>
                <div className={styles.content}>
                    <h4 className={styles.title}>{ this.props.title }</h4>
                </div>
            </div>
        )
    }
}